module.exports = __webpack_public_path__ + "static/img/img_5.f4d993b1.jpg";